import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { TextInput } from "@/shared/components/form/text-input";
import {
  PutRequest,
  useAuthFeatureAuthPutMutation,
} from "@/services/backend/auth/api/feature-auth";

export function FeatureAuthCreateDialog() {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<PutRequest>({
    feature: "",
    requirement: { roles: [], companies: [] },
  });
  const [put, { isLoading, error, isSuccess, reset }] =
    useAuthFeatureAuthPutMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
      setRequest({
        feature: "",
        requirement: { roles: [], companies: [] },
      });
    }
  }, [isSuccess, reset]);

  const doUpdate = () => {
    if (isLoading) return;
    put(request);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm">
          <Plus />
          <span>{t("Regel")}</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Regel bearbeiten")}</DialogTitle>
          <DialogDescription>
            {t(
              "Hier könenn sie die Zugangsbeschränkungen bearbeiten. Wenn nichts ausgewählt ist, können alle Nutzer auf das Feature zugreifen.",
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <TextInput
            label={t("Feature")}
            placeholder={t("Feature Name")}
            text={request?.feature || ""}
            onTextChange={(feature) => setRequest((r) => ({ ...r!, feature }))}
            field="feature"
            errors={null}
          />
        </div>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doUpdate} />
      </DialogContent>
    </Dialog>
  );
}
